import { TagBadge, type TagBadgeProps } from './TagBadge';

export type SignalTagTone = 'rating' | 'secure' | 'trial';

interface SignalTagProps extends TagBadgeProps {
  tone: SignalTagTone;
}

export function SignalTag({ tone, className = '', ...props }: SignalTagProps) {
  return <TagBadge {...props} className={`signal-tag signal-tag-${tone} ${className}`} />;
}
